import React__default, { useContext } from 'react';
import classNames from './../external_lib/classnames/index.js';
import { ThemeContext } from '../provider.js';

/* eslint-disable @typescript-eslint/no-empty-function */
function Typography(_a) {
    var children = _a.children, variant = _a.variant, color = _a.color, weight = _a.weight, fontSize = _a.fontSize, fontStyle = _a.fontStyle, _b = _a.classes, classes = _b === void 0 ? '' : _b, _c = _a.noWrap, noWrap = _c === void 0 ? false : _c, _d = _a.isRequired, isRequired = _d === void 0 ? false : _d, _e = _a.onClickCallback, onClickCallback = _e === void 0 ? function () { } : _e, _f = _a.onMouseEnterCallback, onMouseEnterCallback = _f === void 0 ? function () { } : _f, _g = _a.onMouseLeaveCallback, onMouseLeaveCallback = _g === void 0 ? function () { } : _g, _h = _a.id, id = _h === void 0 ? '' : _h, _j = _a.loading, loading = _j === void 0 ? false : _j, uppercase = _a.uppercase;
    var styles = {};
    useContext(ThemeContext).theme;
    /**
     * To override theme font color
     */
    if (color) {
        styles.color = color;
    }
    /**
     * To override default weight
     */
    if (weight) {
        styles.fontWeight = getWeight(weight);
    }
    if (fontSize) {
        styles.fontSize = "".concat(fontSize, "px");
    }
    if (noWrap) {
        styles.whiteSpace = 'nowrap';
    }
    if (isRequired) {
        classes += ' required-field';
    }
    if (uppercase) {
        classes += ' text-all-caps';
    }
    if (fontStyle) {
        styles.fontStyle = fontStyle;
    }
    if (loading) {
        return React__default.createElement("p", { className: "typo shimmer" });
    }
    // if (!fontSize && theme?.typography?.[variant]?.fontSize) {
    //   styles.fontSize = theme.typography?.[variant]?.fontSize;
    // }
    switch (variant) {
        case 'displayText':
        case 'displayTextMain':
        case 'headingOne':
            return (React__default.createElement("h1", { id: id, style: styles, className: classNames(variant, classes, 'typo'), onClick: onClickCallback, onMouseEnter: onMouseEnterCallback, onMouseLeave: onMouseLeaveCallback }, children));
        case 'headingTwo':
            return (React__default.createElement("h2", { id: id, style: styles, className: classNames(variant, classes, 'typo'), onClick: onClickCallback, onMouseEnter: onMouseEnterCallback, onMouseLeave: onMouseLeaveCallback }, children));
        case 'headingThree':
            return (React__default.createElement("h3", { id: id, style: styles, className: classNames(variant, classes, 'typo'), onClick: onClickCallback, onMouseEnter: onMouseEnterCallback, onMouseLeave: onMouseLeaveCallback }, children));
        default:
            return (React__default.createElement("p", { id: id, style: styles, className: classNames(classes, variant, 'typo'), onClick: onClickCallback, onMouseEnter: onMouseEnterCallback, onMouseLeave: onMouseLeaveCallback }, children));
    }
}
/**
 * @param {string} weight can be normal|semibold|bold|any
 * @returns {number} can be 700|600|400|""
 */
function getWeight(weight) {
    if (weight === 'bold') {
        return 700;
    }
    else if (weight === 'semibold') {
        return 600;
    }
    else if (weight === 'medium') {
        return 500;
    }
    else {
        return 400;
    }
}

export { Typography as default };
//# sourceMappingURL=Typography.js.map
